import React from 'react';
import { RicosButton } from './external-toolbar-utils';
import { VerticallyPositionedContainer } from '../../vertically-positioned-container/vertically-positioned-container';
import { PlusIcon } from '../../icons/plus-icon';
import { useTranslate } from '../../../context/api-context/translations/use-translate';
import { useApi } from '../../../context/api-context/use-api';
import { getIsMobile } from '../../../../common/store/base-params/base-params-selectors';
import DropdownButton from '../../dropdown-button/dropdown-button';
import { st, classes } from './more-plugins-menu.st.css';
export const MorePluginsMenu = ({ buttons, isExtended = false }) => {
    const { isMobile } = useApi((state) => ({ isMobile: getIsMobile(state) }));
    const t = useTranslate();
    return (React.createElement("div", { className: st(classes.root, { isExtended }) },
        React.createElement(DropdownButton, { buttonProps: {
                className: classes.moreButton,
                children: React.createElement(PlusIcon, { className: classes.moreButtonIcon }),
            } }, ({ closeDropdown }) => (React.createElement(VerticallyPositionedContainer, { className: classes.menuContainer, centerHorizontally: true, centerToScreen: isMobile, offset: 24 },
            isExtended && React.createElement("div", { className: classes.title }, t('more-plugins-menu.add-block')),
            React.createElement("div", { className: classes.buttonContainer }, buttons.map((buttonProps) => (React.createElement(RicosButton, { ...buttonProps, className: st(classes.button), iconClass: st(classes.icon), showLabel: isExtended, onClick: (args) => {
                    buttonProps.onClick?.(args);
                }, onChange: (args) => {
                    if (buttonProps.onChange) {
                        closeDropdown();
                        buttonProps.onChange(args);
                    }
                } })))))))));
};
//# sourceMappingURL=more-plugins-menu.js.map